
import React, { useState, useRef, useEffect } from 'react';

const industriesData = [
  { title: "Textile", content: "We provide cutting-edge digital solutions for textile businesses, enabling automation in production, inventory tracking, and quality control. Our solutions help optimize processes from fiber to fabric.", img: "/assets/img/Industries/I1.jpg" },
  { title: "Dyeing", content: "Our software streamlines dyeing operations, ensuring precision in color matching, chemical usage optimization, and waste reduction, enhancing sustainability and compliance.", img: "/assets/img/Industries/I2.jpg" },
  { title: "Weaving", content: "We help weaving units digitize production management, track loom efficiency, and ensure seamless integration between design and manufacturing for improved productivity.", img: "/assets/img/Industries/I3.jpg" },
  { title: "Processing", content: "From pre-treatment to finishing, we offer software solutions that enhance processing efficiency, minimize defects, and optimize resource utilization.", img: "/assets/img/Industries/I4.jpg" },
  { title: "Knitting", content: "We empower knitting businesses with real-time monitoring tools, automated production planning, and quality assurance systems, ensuring smooth operations.", img: "/assets/img/Industries/I5.jpg" },
  { title: "Garmenting", content: "Our ERP and automation solutions help garment manufacturers manage order processing, production scheduling, supply chain logistics, and quality control efficiently.", img: "/assets/img/Industries/I6.jpg" },
  { title: "E-Commerce", content: "We develop robust e-commerce platforms with advanced features such as AI-powered recommendations, seamless payment gateways, and personalized shopping experiences to drive sales.", img: "/assets/img/Industries/I7.jpg" },
  { title: "Manufacturing", content: "Our manufacturing solutions streamline production workflows, enhance inventory management, and integrate smart factory technologies to improve efficiency and reduce downtime.", img: "/assets/img/Industries/I8.jpg" },
  { title: "Carpet", content: "We provide digital solutions for design, production tracking, and supply chain management, helping carpet manufacturers optimize production and distribution.", img: "/assets/img/Industries/I9.jpg" },
  { title: "Chemical", content: "Our solutions support chemical manufacturers with compliance management, safety regulations, batch tracking, and efficient raw material utilization to ensure operational excellence.", img: "/assets/img/Industries/I10.jpg" },
  { title: "Legacy App Development", content: "We help businesses transition from outdated legacy systems to modern, cloud-based, and AI-driven applications, ensuring scalability, security, and improved performance.", img: "/assets/img/Industries/I11.jpeg" },
  { title: "Gen AI App Development", content: "Our expertise in GenAI helps businesses leverage AI for automation, personalized content creation, advanced analytics, and intelligent decision-making across industries.", img: "/assets/img/Industries/I12.jpg" }
];

const IndustriesSection = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="industries-section"
      ref={sectionRef}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'none' : 'translateY(40px)',
        transition: 'opacity 1s cubic-bezier(0.25,0.1,0.25,1), transform 1s cubic-bezier(0.25,0.1,0.25,1)',
      }}
    >

      {/* Heading */}
      <h2
        className="industries-heading"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'none' : 'translateY(30px)',
          transition: 'opacity 1s cubic-bezier(0.25,0.1,0.25,1) 0.1s, transform 1s cubic-bezier(0.25,0.1,0.25,1) 0.1s',
        }}
      >
        Industries We Serve
      </h2>

      <div className="industries-grid">

        {/* Sidebar */}
        <div
          className="industries-sidebar"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'none' : 'translateX(-30px)',
            transition: 'opacity 1s cubic-bezier(0.25,0.1,0.25,1) 0.2s, transform 1s cubic-bezier(0.25,0.1,0.25,1) 0.2s',
          }}
        >
          {industriesData.map((item, index) => (
            <div
              key={index}
              onClick={() => setActiveTab(index)}
              className={`industry-tab ${activeTab === index ? 'active' : ''}`}
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'none' : 'translateX(-20px)',
                transition: `opacity 0.8s cubic-bezier(0.25,0.1,0.25,1) ${0.2 + index * 0.05}s, transform 0.8s cubic-bezier(0.25,0.1,0.25,1) ${0.2 + index * 0.05}s`,
              }}
            >
              {item.title}
            </div>
          ))}
        </div>

        {/* Content */}
        <div
          className="content-display"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'none' : 'translateX(30px)',
            transition: 'opacity 1s cubic-bezier(0.25,0.1,0.25,1) 0.3s, transform 1s cubic-bezier(0.25,0.1,0.25,1) 0.3s',
          }}
        >
          <div className="image-box">
            <img
              src={industriesData[activeTab].img}
              alt={industriesData[activeTab].title}
              className="hero-img"
              onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200"; }}
            />
            <div className="glass-card">
              <h3 className="card-title">{industriesData[activeTab].title}</h3>
              <p className="card-desc">{industriesData[activeTab].content}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default IndustriesSection;